import { render, staticRenderFns } from "./StepsLine.vue?vue&type=template&id=20b5e87f&scoped=true"
import script from "./StepsLine.vue?vue&type=script&lang=js"
export * from "./StepsLine.vue?vue&type=script&lang=js"
import style0 from "./StepsLine.vue?vue&type=style&index=0&id=20b5e87f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b5e87f",
  null
  
)

export default component.exports